const connectivityCheck = () => {
    return {
        online: undefined,
        handleScrollPosition() {
            const scroll = document.documentElement.scrollTop;

            if(scroll > 0){
                this.$el.classList.add('fixed');
                this.$el.classList.remove('relative');
            } else {
                this.$el.classList.add('relative');
                this.$el.classList.remove('fixed');
            }
        },
        handleOfflineMode() {
            this.online = false;

            this.handleScrollPosition();
            this.$dispatch('close-any-opened-modal');
        },
        handleOnlineMode() {
            if(this.online === undefined){
                return;
            }

            this.online = true;
            setTimeout(() => this.online = undefined, 3500);
        },
    }
};

export default connectivityCheck;